'use client'

import { PGlite } from "@electric-sql/pglite";
import { PGliteProvider } from "@electric-sql/pglite-react";
import type { ReactNode} from "react";
import { live } from "@electric-sql/pglite/live";

import { useQuery } from "@tanstack/react-query";
import { Loading } from "@/components/ui/loading";
import { ErrorDisplay } from "@/components/ui/error";

export function PGliteDbProvider({ children }: { children: ReactNode }) {
  const { data: db, isLoading, error, refetch } = useQuery({
    queryKey: ["pglite-db"],
    queryFn: async () => {
      return await PGlite.create({ extensions: { live } });
    },
  });

  if (isLoading) {
    return <Loading message="Initializing database..." />;
  }

  if (error) {
    return (
      <ErrorDisplay
        message={(error as Error).message}
        onRetry={() => refetch()}
      />
    );
  }

  return <PGliteProvider db={db}>{children}</PGliteProvider>;
}
